
import { useEffect, useRef, useState } from 'react';

interface InFeedAdUnitProps {
  className?: string;
}

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export default function InFeedAdUnit({ className = '' }: InFeedAdUnitProps) {
  const adRef = useRef<HTMLDivElement>(null);
  const isInitialized = useRef(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let checkCount = 0;
    const maxChecks = 100;
    
    const checkContainer = () => {
      if (adRef.current && checkCount < maxChecks) {
        const rect = adRef.current.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(adRef.current);
        const hasWidth = rect.width > 0 || parseInt(computedStyle.width) > 0;
        
        if (hasWidth && rect.width >= 250) {
          setIsReady(true);
        } else {
          checkCount++;
          setTimeout(checkContainer, 100);
        }
      }
    };

    setTimeout(checkContainer, 1000);
  }, []);

  useEffect(() => {
    if (!isReady || isInitialized.current) return;

    const loadAd = () => {
      if (adRef.current) {
        const rect = adRef.current.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(adRef.current);
        const actualWidth = rect.width || parseInt(computedStyle.width) || 0;
        
        if (actualWidth < 250) {
          console.warn('InFeed AdSense container width too small:', actualWidth);
          return;
        }
      }

      if (!document.querySelector('script[src*="adsbygoogle.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1204278699094462';
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);
        
        script.onload = () => {
          setTimeout(() => {
            try {
              const containers = document.querySelectorAll('.adsbygoogle');
              containers.forEach((container) => {
                const rect = container.getBoundingClientRect();
                if (rect.width >= 250 && !container.getAttribute('data-adsbygoogle-status')) {
                  (window.adsbygoogle = window.adsbygoogle || []).push({});
                }
              });
            } catch (err) {
              console.error('AdSense error:', err);
            }
          }, 2000);
        };
      } else {
        setTimeout(() => {
          try {
            const containers = document.querySelectorAll('.adsbygoogle:not([data-adsbygoogle-status])');
            containers.forEach((container) => {
              const rect = container.getBoundingClientRect();
              if (rect.width >= 250) {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
              }
            });
          } catch (err) {
            console.error('AdSense error:', err);
          }
        }, 2000);
      }
    };

    setTimeout(loadAd, 1500);
    isInitialized.current = true;
  }, [isReady]);

  return (
    <div ref={adRef} className={`${className} w-full my-8`}>
      {isReady && (
        <ins
          className="adsbygoogle"
          style={{ display: 'block', minWidth: '250px' }}
          data-ad-format="autorelaxed"
          data-ad-client="ca-pub-1204278699094462"
          data-ad-slot="5933976238"
        ></ins>
      )}
    </div>
  );
}
